export type DetachListener = () => void;

export interface IValueProducer<T> {
    readonly currentValue: Promise<T>;
    onNext(listener: (nextValue: T) => Promise<void>): DetachListener;
    onError(listener: (error: Error) => Promise<void>): DetachListener;
    beginObserve(): Promise<void>;
    endObserve(): Promise<void>;
}

export type ValueListener<T> = (nextValue: T) => Promise<void>;
